import type { ForwardStatus } from '@nucleus-commerce/api-client/admin';

export type ForwardReason =
  | { kind: 'consent' }
  | { kind: 'unsupported' }
  | { kind: 'error'; excerpt: string }
  | { kind: 'none' };

/** `reason` is a fixed code for skips and the platform's error excerpt for failures. */
export function forwardReason(forward: ForwardStatus): ForwardReason {
  const { reason } = forward;
  if (reason === null || reason === '') return { kind: 'none' };
  if (reason === 'consent') return { kind: 'consent' };
  if (reason === 'unsupported_event') return { kind: 'unsupported' };
  return { kind: 'error', excerpt: reason };
}
